module.exports = __webpack_public_path__ + "img/pc_footer_bg.bf3f64a.webp";